<template>
  <div v-if="isMaxScreen">
    <Head></Head>
    <div class="pc_pre-price">
      <div style="flex: 1; overflow-y: auto; height: 100%">
        <PC-order-step></PC-order-step>
        <PC-bread-nav></PC-bread-nav>
        <div class="device-main">
          <div class="device-item">
            <PC-device-info :data="evaluationInfo"></PC-device-info>
            <PC-user-info :info="info" @completeData="completeData"></PC-user-info>
          </div>
        </div>
      </div>
    </div>

    <PC-bottom-button
      :disabled="!disabled"
      :data="evaluationInfo"
      :btnName = "$t('PCBottomButton.index.settleaccountBtn')"
      :showSelect="true"
      @handleSubmit="showDialog"
    ></PC-bottom-button>
    <el-dialog
      :title="$t('PCBottomButton.index.dialogTitle')"
      :visible.sync="centerDialogVisible"
      center
      class="pc_dialog"
      width="335px"
    >
      <span class="dialogText">
        {{ $t('PCBottomButton.index.dialogText') }}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="sureBtn" @click="pcSubmit">{{
          $t('PCBottomButton.index.dialogBtn')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="settle-account">
    <h-head></h-head>
    <PersonInfo ref="person" :info="info" @completePerson="completePerson"></PersonInfo>
    <AddressInfo ref="address" :info="info" @completeAddress="completeAddress"></AddressInfo>
    <BillInfo ref="bill" :info="info" @completeBill="completeBill"></BillInfo>
    <emailInfo ref="email" :info="info" @completeEmail="completeEmail"></emailInfo>
    <!-- imei -->
    <!-- <div class="imei-info">
      <div class="title">Código IMEI (Nuevo dispositivo)</div>
      <div class="input-content">
        <input
          v-model="imei"
          type="number"
          class="input"
          placeholder="Please enter"
          oninput="if(value.length>15)value=value.slice(0,15)"
        />
        <div class="number">{{ imei ? imei.length : 0 }}/15</div>
      </div>
    </div>
    <ImeiPhoto ref="imei" @changeImeiPhoto="changeImeiPhoto"></ImeiPhoto> -->

    <van-dialog
      v-model="centerDialogVisible"
      :title="$t('PCBottomButton.index.dialogTitle')"
      :show-confirm-button="false"
      close-on-click-overlay
      class="h5_dialog"
    >
      <p>
        {{ $t('PCBottomButton.index.dialogText') }}
      </p>
      <div class="btn-box">
        <van-button class="btn2" @click="pcSubmit">{{
          $t('PCBottomButton.index.dialogBtn')
        }}</van-button>
      </div>
    </van-dialog>
    <footer>
      <div class="footer">
        <div class="bottom-select">
          <img
            v-if="select"
            src="@/assets/PC/img/select.png"
            alt=""
            class="selectIcon"
            @click="select = !select"
          />
          <img
            v-else
            src="@/assets/PC/img/unselect.png"
            alt=""
            class="selectIcon"
            @click="select = !select"
          />
          {{ $t('PCBottomButton.index.647hqss760c0') }}
          <span @click="goto(1)">&nbsp;{{ $t('PCBottomButton.index.647hqss764w0') }}</span> &
          <span @click="goto(2)">{{ $t('PCBottomButton.index.647hqss76ac0') }}</span>
        </div>
        <van-button
          :class="[disabled ? 'btn-active' : '', 'btn-photo']"
          :loading="loading"
          :loading-text="$t('PCUserInfo.index.submit')"
          loading-type="spinner"
          @click="showDialog"
          >{{ $t('PCUserInfo.index.submit') }}</van-button
        >
      </div>
    </footer>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import hHead from '@/components/layout/head.vue';
import PCBottomButton from '@/components/PCBottomButton';
import PCBreadNav from '@/components/PCBreadNav';
import PCOrderStep from '@/components/PCOrderStep';
import { officialSubmit } from '@/services/api/product';
import { getChannelId , getNationCode } from '@/utils/channel';
import PCDeviceInfo from '@/views/evaluate/components/PCDeviceInfo';

import Head from '../../components/head';
import CryptoFn from '../../utils/crypto';
import AddressInfo from './components/addressInfo.vue';
import BillInfo from './components/billInfo.vue';
import emailInfo from './components/emailInfo.vue';
import ImeiPhoto from './components/imeiPhoto.vue';
import PCUserInfo from './components/PCUserInfo';
import PersonInfo from './components/personInfo.vue';
export default {
  name: 'SettleAccount',
  components: {
    PersonInfo,
    BillInfo,
    AddressInfo,
    ImeiPhoto,
    Head,
    PCBreadNav,
    PCOrderStep,
    PCBottomButton,
    PCDeviceInfo,
    PCUserInfo,
    hHead,
    emailInfo
  },
  data() {
    return {
      evaluationInfo: {},
      info: {
        userName: '',
        mobile: '',
        countryCode: '',
        pinCode: '',
        city: '',
        address: '',
        bic: '',
        idCard: '',
        iban: '',
        email: '',
        mobileAreaCode: '',
        code: ''
      },
      imei: '',
      loading: false,
      canClick: false,
      isPersonInfoComplete: false,
      isBillInfoComplete: false,
      isAddressInfoComplete: false,
      isEmailComplete: false,
      disabled: false,
      select: false,
      centerDialogVisible: false,
      isDownload: false,
      isPass: false,
      channel: getChannelId() || '100000'
    };
  },
  computed: {
    // 判断是否是 PC 端
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  created() {
    console.log(13245689798)
    // 根据渠道设置默认手机号区号
    this.setDefaultMobileAreaCode();

    if (this.$route.query.data){
      this.evaluationInfo = JSON.parse(this.$route.query.data);
    }

    console.log(this.$store.state.pageData)
    // 从 Vuex 恢复数据
    if (this.$store.state.pageData) {
      const pageData = this.$store.state.pageData
      console.log('pageData', pageData)
      this.info = pageData;
      this.isDownload = pageData.isDownload
      this.isPass = pageData.isPass
    }
  },
  mounted() {
  },
  activated() {
  },

  beforeRouteLeave(to, from, next) {
    if (to.path === '/cookiePriva' || to.path === '/termsAndConditions') {
      this.$store.commit('setPageData', { ...this.info, isDownload: this.isDownload, isPass: this.isPass });
    } else {
      this.$store.commit('clearPageData');
    }
    next(); // 必须调用 next() 才能继续导航
  },
  methods: {
    // 设置默认的手机号区号
    setDefaultMobileAreaCode() {
      // 奥地利渠道（线上 100070 或线下 100080）使用 +43
      // if (this.channel === '100070' || this.channel === '100080') {
      //   this.info.mobileAreaCode = '+43';
      // }

      const nationCode = getNationCode();

      console.log('nationCode', nationCode)

      // 国家码与国际区号映射
      const areaCodeMap = {
        ES: '+34', // 西班牙
        AT: '+43', // 奥地利
        DE: '+49' // 德国
      };

      const defaultAreaCode = areaCodeMap[nationCode] || areaCodeMap.ES;

      console.log('defaultAreaCode', defaultAreaCode)
      this.info.mobileAreaCode = defaultAreaCode;

    },
    showDialog() {
      if (!this.isDownload) {
        this.$toast(this.$t('components.successMain.downloadDec'));
        return;
      }
      if (!this.select && !this.isMaxScreen) {
        this.$toast(this.$t('component.tradeInProcess.toastTip'));
        return;
      }
      if (!this.disabled) {
        return;
      }
      this.centerDialogVisible = true;
    },

    goto(type) {
      if (type == 1) {
        this.$router.push({ name: 'cookiePriva' });
      } else {
        this.$router.push({ name: 'TermsAndConditions' });
      }
    },

    completePerson(data) {
      this.isPersonInfoComplete = data.flag;
      this.info = { ...this.info, ...data.form };
    },
    completeBill(data) {
      this.isBillInfoComplete = data.flag;
      this.info = { ...this.info, ...data.form };
    },
    completeAddress(data) {
      this.isAddressInfoComplete = data.flag;
      this.info = { ...this.info, ...data.form };
    },
    completeEmail(data, isDownload) {
      console.log('email', data, isDownload)
      this.isDownload = isDownload;
      this.isPass = data.flag;
      this.isEmailComplete = data.flag && isDownload;
      this.info = { ...this.info, ...data.form };
    },

    completeData(data, isPass, isDownload) {
      const {
        userName,
        mobile,
        countryCode,
        pinCode,
        city,
        address,
        // bic,
        idCard,
        iban,
        email,
        mobileAreaCode
      } = data;
      this.info = { ...data };
      this.isDownload = isDownload;
      this.isPass = isPass;

      console.log(data, isPass, isDownload)

      if (
        userName &&
        mobile &&
        countryCode &&
        pinCode &&
        city &&
        address &&
        // bic &&
        idCard &&
        iban &&
        email &&
        isPass &&
        isDownload
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    /**
     * 提交订单
     */
    pcSubmit() {
      const crypt = new CryptoFn();
      const {
        userName,
        mobile,
        countryCode,
        pinCode,
        city,
        address,
        idCard,
        // bic,
        iban,
        email,
        mobileAreaCode
      } = this.info;
      const { evaluationId, bonus } = this.evaluationInfo;
      let data = {
        channelId: this.channel,
        estimatedId: evaluationId,
        bonus,
        userName,
        email,
        mobile: mobileAreaCode + mobile,
        countryCode: countryCode,
        pinCode,
        city,
        address,
        // bic: iban,
        iban,
        idCard
      };
      console.log(data);
      data = crypt.encrypt(JSON.stringify(data));
      officialSubmit({ data })
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            this.$router.push({
              path: '/successOrder',
              query: {
                data: JSON.stringify(data),
                keepalive: 2
              }
            });
          }
        })
        .catch(err => {});
    },
    /**
     * 提交订单
     */
    submit() {
      if (!this.canClick) {
        return;
      }
      const crypt = new CryptoFn();
      const { evaluationId, bonus } = this.evaluationInfo;
      const { userName, email, mobile } = this.$refs.person.form;
      const { iban } = this.$refs.bill.form;
      const { countryCode, postalCode, city, address } = this.$refs.address.form;
      let data = {
        channelId: 10000,
        estimatedId: evaluationId,
        bonus,
        newMachineImei: this.imei,
        userName,
        email,
        mobile,
        // bank,
        // bankCard,
        bic: iban,
        iban,
        countryCode,
        pinCode: postalCode,
        city,
        address
      };
      data = crypt.encrypt(JSON.stringify(data));
      officialSubmit({ data })
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            localStorage.setItem('cachedUserInfo', {});
            this.$router.push({
              path: '/successOrder',
              query: { email }
            });
          }
        })
        .catch(err => {});
    }
  }
  // beforeRouteLeave(to, from, next) {
  //   console.log("to.query.keepalive",to.query.keepalive)
  //   if (to.query.keepalive == 2) {
  //     localStorage.removeItem('cachedUserInfo');
  //   }
  //   next();
  // },
};
</script>

<style lang="less" scoped>
@media (max-width: 981px) {
  .footer {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .bottom-select {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    line-height: 50px;
    margin-bottom: 16px;
    img {
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }
    span {
      color: #405fff;
    }
  }
  .settle-account {
    background: #f4f5f7;
    padding: 24px;
    box-sizing: border-box;
    margin-bottom: 200px;
    .imei-info {
      width: 100%;
      box-sizing: border-box;
      color: #fff;
      margin-bottom: 24px;
      background: #fff;
      border-radius: 20px;
      padding: 0 24px;
      .title {
        height: 84px;
        font-size: 32px;
        font-weight: 500;
        color: #333;
        line-height: 84px;
      }
      .input-content {
        position: relative;
        .input {
          width: 100%;
          height: 92px;
          background: #f7f7f7;
          padding: 32px 24px;
          box-sizing: border-box;
          color: #333;
          font-size: 28px;
          border: none;
          border-radius: 12px;
          margin-bottom: 24px;
        }
        .number {
          position: absolute;
          top: 32px;
          right: 24px;
          font-size: 24px;
          color: #999;
        }
      }
    }
    footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 999;
      display: flex;
      align-items: center;
      background: #fff;
      padding: 10px 24px !important;
      font-size: 28px;
      .btn-photo {
        height: 80px;
        width: 100%;
        text-align: center;
        line-height: 80px;
        background: #405fff !important;
        color: #fff !important;
        border-radius: 5px;
        opacity: 0.5;
        border-radius: 16px;
      }
      .btn-active {
        background: #405fff !important;
        color: #fff !important;
        opacity: 1 !important;
      }
    }
    /deep/ .van-uploader__preview-delete {
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      border-radius: 12px;
    }
    /deep/ .van-uploader__preview-delete-icon {
      font-size: 20px;
      top: 0;
      right: 0;
    }
  }

  /deep/ .van-dialog__header{
    font-weight: bold;
  }

  .h5_dialog {
    p {
      color: var(---Text-2, #5d5f65);
      font-family: 'PingFang SC';
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: 48px;
      margin: 32px 44px 52px;
    }

    .btn-box {
      display: flex;
      justify-content: space-between;
      margin: 32px 44px;
    }

    .btn1 {
      display: flex;
      flex: 1;
      height: 88px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      margin-right: 16px;
      border-radius: 10px;
      background: #f5f6f9;
      color: var(---Text-1, var(---Text-1, #252629));
      border: none;
    }
    .btn2 {
      display: flex;
      flex: 1;
      height: 88px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      border-radius: 10px;
      background: var(---Brand-1, #405fff);
      color: #fff;
      border: none;
    }
  }
}

@media (min-width: 981px) {
  .pc_pre-price {
    background-color: #f8f8f8;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    width: 1200px;
    margin: 100px auto 0;
    .device-main {
      display: flex;
      justify-content: center;
      margin-bottom: 40px;
      .device-item {
        width: 1200px;
        display: flex;
        justify-content: space-between;
      }
    }
  }


}

.pc_dialog {
    .sureBtn {
      width: 287px;
      height: 44px;
      background: #405fff;
      color: #fff;
      color: #fff;

      text-align: center;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 15.04px; /* 115.692% */
      border: none;
    }

    .dialogText {
      color: var(---Text-1, var(---Text-1, #252629));
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px; /* 157.143% */
      text-align: center;
      display: block;
    }

    /deep/.el-dialog__title {
      color: var(---Text-1, var(---Text-1, #252629));
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      line-height: normal;
      font-weight: bold;
    }
    /deep/.el-dialog__footer {
      padding-top: 0;
    }
    /deep/.el-dialog {
      border-radius: 8px;
    }
    /deep/.el-dialog__close {
      color: #000;
      font-weight: bold;
    }
  }
</style>
